exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.panel-notification.is-scroll[data-v-5261b6e6] {\n    height: calc(100% - 250px) !important;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build/frontend/shipper/src/components/modules/courier-dashboard/entityList.vue"],"names":[],"mappings":";AACA;IACI,sCAAsC;CACzC","file":"entityList.vue","sourcesContent":["\n.panel-notification.is-scroll[data-v-5261b6e6] {\n    height: calc(100% - 250px) !important;\n}\n"],"sourceRoot":""}]);

// exports
